import { call, put } from "redux-saga/effects";
import { setError as error } from "actions/error";
import axios from "axios";
import { logOff } from "actions/auth";
import Logger from "./log/Logger";
import history from "./history";

export function extractErrorMessage(e: any): string {
    if (typeof e === "string") {
        return e;
    }

    // Try variant typing
    const e1 = e.judoDetails?.details?.[0]?.message;
    if (typeof e1 === "string" && e1) {
        return e1;
    }

    const e2 = e.judoDetails?.message;
    if (typeof e2 === "string" && e2) {
        return e2;
    }

    // This takes priority over e.message since it is more likely to contain self-fix suggestions
    const e4 = e.response?.data?.message;
    if (typeof e4 === "string" && e4) {
        return e4;
    }

    const e3 = e.message;
    if (typeof e3 === "string" && e3) {
        return e3;
    }

    // console.error("Unknown error", e);
    return "An unknown error occurred, if this error persists please contact us.";
}

export function errorToDiagnosticsString(e: any): string {
    if (typeof e === "string") {
        return e;
    }

    if (!e) {
        return "Empty diagnostics error";
    }

    let details = "";

    try {
        details = `Raw: ${e}`;
    } catch {
        /* Don't fail if this fails, it just means the error details will not have Raw data  */
    }

    // Try variant typing
    const e1 = e.judoDetails?.details?.[0]?.message;
    if (typeof e1 === "string" && e1) {
        details = `${details} :: e1: ${e1}`;
    }

    const e2 = e.judoDetails?.message;
    if (typeof e2 === "string" && e2) {
        details = `${details} :: e2: ${e2}`;
    }

    const e4 = e.response?.data?.message;
    if (typeof e4 === "string" && e4) {
        details = `${details} :: e4: ${e4}`;
    }

    const e3 = e.message;
    if (typeof e3 === "string" && e3) {
        details = `${details} :: e3: ${e3}`;
    }

    try {
        return `${details} :: stringify: ${JSON.stringify(e)}`;
    } catch {
        /* Don't fail if this fails, it just means the error details will not have JSON data  */
    }

    return details;
}

export function* setError(e: Error | string | unknown, errorCode?: string) {
    Logger.error(e);

    try {
        yield call(() =>
            axios.post(`/api/payment/errors`, {
                siteId: null,
                details: errorToDiagnosticsString(e),
                code: errorCode,
            })
        );
    } catch {
        /* Don't fail if this fails as that would hide any nice errors from the user */
    }

    if (axios.isAxiosError(e) && e.response!.status !== 500) {
        if (e.response!.status === 404) {
            history.push("/not-found");
            return;
        }
        if (e.response!.status === 401) {
            yield put(logOff());
            return;
        }
        if (e.response!.status === 403) {
            history.replace("/forbidden");
            return;
        }
    }

    yield put(error({ error: extractErrorMessage(e), errorCode }));

    history.push("/error");
}
